import React, { useEffect, useState } from 'react';
import supabase from './supabaseClient';
import './App.css'; // Import global styles for modern font and base styles
import { UDYAM_REG_NUMBER } from './constants';
import { createClient } from '@supabase/supabase-js';

// Replace with your actual Supabase project credentials:
const supabaseUrl = 'https://rqtzciglkenqnvtcpbyd.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJxdHpjaWdsa2VucW52dGNwYnlkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA3MzAyMTcsImV4cCI6MjA5NjMwNjIxN30.dkYNQUipGUBW8po66BZip6O2IFmU21A7utXMty5bTuc';

function AdminPanel() {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [verifyId, setVerifyId] = useState('');
  const [verifyResult, setVerifyResult] = useState(null);
  const [addForm, setAddForm] = useState({
    name: '',
    duration: '',
    department: '',
    startDate: '',
    endDate: '',
    issueDate: '',
    certificateId: '',
  });
  const [addStatus, setAddStatus] = useState('');
  const [showThankYou, setShowThankYou] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [verifyInput, setVerifyInput] = useState('');
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [verifyResultModal, setVerifyResultModal] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState(null);
  const [editSuccess, setEditSuccess] = useState(false);
  const [authUser, setAuthUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [addUserForm, setAddUserForm] = useState({ username: '', email: '', password: '', is_admin: true });
  const [addUserStatus, setAddUserStatus] = useState('');

  useEffect(() => {
    fetchCertificates();
  }, []);

  async function fetchCertificates() {
    setLoading(true);
    const { data, error } = await supabase
      .from('certificates')
      .select('*')
      .order('issueDate', { ascending: false });
    if (!error) setCertificates(data);
    setLoading(false);
  }

  async function handleVerify(e) {
    e.preventDefault();
    setVerifyResult(null);
    const { data, error } = await supabase
      .from('certificates')
      .select('*')
      .eq('certificateId', verifyId)
      .single();
    if (error || !data) setVerifyResult('Certificate not found.');
    else setVerifyResult(data);
  }

  async function handleAdd(e) {
    e.preventDefault();
    setAddStatus('');
    if (!addForm.name || !addForm.certificateId) {
      setAddStatus('Name and Certificate ID are required.');
      return;
    }
    const { error } = await supabase
      .from('certificates')
      .insert([addForm]);
    if (error) setAddStatus('Error adding certificate: ' + error.message);
    else {
      setAddStatus('');
      setShowThankYou(true);
      setShowAddModal(false);
      setAddForm({ name: '', duration: '', department: '', startDate: '', endDate: '', issueDate: '', certificateId: '' });
      fetchCertificates();
    }
  }

  async function handleDeleteConfirmed() {
    if (!deleteTargetId) return;
    const { error } = await supabase
      .from('certificates')
      .delete()
      .eq('certificateId', deleteTargetId);
    if (error) {
      setDeleteMessage('Error deleting certificate: ' + error.message);
    } else {
      setDeleteMessage('Certificate deleted successfully!');
      setShowDeleteSuccess(true);
      fetchCertificates();
    }
    setShowDeleteConfirm(false);
    setDeleteTargetId(null);
  }

  // Generalized duration handler for both add and edit forms
  function formatDurationInput(value) {
    // Remove any existing 'month' or 'months' suffix
    let cleaned = value.replace(/\s*months?$/i, '');
    // If value is only digits, append 'month' or 'months'
    if (/^\d+$/.test(cleaned)) {
      return cleaned + (cleaned === '1' ? ' month' : ' months');
    }
    return value;
  }

  function handleDurationChange(e) {
    setAddForm({ ...addForm, duration: formatDurationInput(e.target.value) });
  }

  function handleEditDurationChange(e) {
    setEditForm({ ...editForm, duration: formatDurationInput(e.target.value) });
  }

  async function handleVerifyModal(e) {
    e.preventDefault();
    setVerifyLoading(true);
    setVerifyResultModal(null);
    const { data, error } = await supabase
      .from('certificates')
      .select('*')
      .eq('certificateId', verifyInput)
      .single();
    setVerifyLoading(false);
    if (error || !data) setVerifyResultModal('Certificate not found.');
    else setVerifyResultModal(data);
  }

  async function handleEditSave(e) {
    e.preventDefault();
    if (!editForm.name || !editForm.certificateId) return;
    const { error } = await supabase
      .from('certificates')
      .update({
        name: editForm.name,
        duration: editForm.duration,
        department: editForm.department,
        startDate: editForm.startDate,
        endDate: editForm.endDate,
        issueDate: editForm.issueDate,
      })
      .eq('certificateId', editForm.certificateId);
    if (!error) {
      setEditSuccess(true);
      fetchCertificates();
      setTimeout(() => {
        setEditSuccess(false);
        setShowEditModal(false);
        setEditForm(null);
      }, 1200);
    }
  }

  function handleNameChange(e) {
    setAddForm({ ...addForm, name: e.target.value.toUpperCase() });
  }

  function handleEditNameChange(e) {
    setEditForm({ ...editForm, name: e.target.value.toUpperCase() });
  }

  async function handleLogin(e) {
    e.preventDefault();
    setLoginError('');
    setAuthLoading(true);
    // Query the users table for the username
    const { data, error } = await supabase
      .from('users')
      .select('*')
      .eq('username', loginForm.username)
      .single();
    if (error || !data) {
      setLoginError('Invalid credentials');
      setAuthLoading(false);
      return;
    }
    // WARNING: For demo only! In production, hash the password and compare hashes.
    if (loginForm.password === data.password_hash) {
      setAuthUser({ username: data.username, is_admin: data.is_admin });
    } else {
      setLoginError('Invalid credentials');
    }
    setAuthLoading(false);
  }

  function handleLogout() {
    setAuthUser(null);
  }

  async function handleAddUser(e) {
    e.preventDefault();
    setAddUserStatus('');
    if (!addUserForm.username || !addUserForm.email || !addUserForm.password) {
      setAddUserStatus('All fields are required.');
      return;
    }
    // For demo: store password as plain text in password_hash
    const { error } = await supabase
      .from('users')
      .insert([{ 
        username: addUserForm.username, 
        email: addUserForm.email, 
        password_hash: addUserForm.password, 
        is_admin: addUserForm.is_admin 
      }]);
    if (error) setAddUserStatus('Error: ' + error.message);
    else {
      setAddUserStatus('Admin user added successfully!');
      setAddUserForm({ username: '', email: '', password: '', is_admin: true });
    }
  }

  if (authLoading) return <div style={{ textAlign: 'center', marginTop: 100, fontSize: 24 }}>Loading...</div>;
  if (!authUser) {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#f8fafc 60%,#e0e7ef 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ maxWidth: 400, width: '100%', background: '#fff', borderRadius: 20, boxShadow: '0 8px 32px #0002', padding: 36, position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src="/logo.png" alt="Logo" style={{ width: 70, height: 70, borderRadius: '50%', marginBottom: 12, objectFit: 'cover', background: '#fff', border: '2px solid #2c3f48' }} />
          <h2 style={{ color: '#162935', marginBottom: 8, textAlign: 'center', fontWeight: 900, fontSize: 30, letterSpacing: 1 }}>Admin Login</h2>
          <div style={{ color: '#64748b', fontSize: 16, marginBottom: 18, textAlign: 'center' }}>Welcome to the Global ServiceX Admin Panel</div>
          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 18, width: '100%' }}>
            <input type="text" placeholder="Username" value={loginForm.username || ''} onChange={e => setLoginForm({ ...loginForm, username: e.target.value })} style={{ padding: 14, borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: 16, background: '#f8fafc', outline: 'none', transition: 'border 0.2s' }} required />
            <input type="password" placeholder="Password" value={loginForm.password} onChange={e => setLoginForm({ ...loginForm, password: e.target.value })} style={{ padding: 14, borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: 16, background: '#f8fafc', outline: 'none', transition: 'border 0.2s' }} required />
            <button type="submit" style={{ padding: '14px 0', borderRadius: 10, background: 'linear-gradient(90deg,#162935,#2c3f48)', color: '#fff', border: 'none', fontWeight: 800, fontSize: 18, cursor: 'pointer', marginTop: 8, boxShadow: '0 2px 8px #0001', letterSpacing: 1 }}>Login</button>
            {loginError && <div style={{ color: 'red', marginTop: 8, textAlign: 'center' }}>{loginError}</div>}
          </form>
          <div style={{ color: '#888', fontSize: 13, marginTop: 18, textAlign: 'center' }}>
            <b>Note:</b> For demo only. In production, always hash passwords and use HTTPS.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#f8fafc 60%,#e0e7ef 100%)', padding: 0 }}>
      <div style={{ maxWidth: 1100, margin: '2.5rem auto', background: '#fff', borderRadius: 28, boxShadow: '0 8px 32px #0002', padding: 48, fontFamily: 'Inter, Montserrat, Arial, sans-serif', minHeight: 700, position: 'relative' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
          <div style={{ fontSize: 22, color: '#162935', fontWeight: 800, letterSpacing: 1 }}>Hi, {authUser?.username || 'Admin'}!</div>
          <div style={{ display: 'flex', gap: 12 }}>
            <button onClick={() => setShowAddUserModal(true)} style={{ padding: '8px 24px', borderRadius: 8, background: 'linear-gradient(90deg,#FFC727,#FFD95A)', color: '#162935', border: 'none', fontWeight: 700, fontSize: 16, cursor: 'pointer', boxShadow: '0 2px 8px #0001' }}>Add Admin User</button>
            <button onClick={handleLogout} style={{ padding: '8px 24px', borderRadius: 8, background: '#ff4d4f', color: '#fff', border: 'none', fontWeight: 700, fontSize: 16, cursor: 'pointer', boxShadow: '0 2px 8px #0001' }}>Logout</button>
          </div>
        </div>
        <h2 style={{ color: '#162935', marginBottom: 8, fontWeight: 900, fontSize: 36, letterSpacing: 1 }}>Admin Panel</h2>
        <div style={{ marginBottom: 32, color: '#64748b', fontSize: 18, borderBottom: '1px solid #e2e8f0', paddingBottom: 16 }}>
          <b style={{ color: '#162935' }}>Total Certificates:</b> {loading ? 'Loading...' : certificates.length}
        </div>
        <h3 style={{ color: '#2c3f48', fontWeight: 800, fontSize: 26, marginBottom: 18 }}>All Certificates</h3>
        <div style={{ maxHeight: 340, overflowY: 'auto', marginBottom: 40, borderRadius: 16, boxShadow: '0 2px 12px #0001', background: '#fff', border: '1px solid #e2e8f0' }}>
          <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, borderRadius: 16, overflow: 'hidden', fontSize: 16 }}>
            <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
              <tr style={{ background: 'linear-gradient(90deg,#f4f6fa,#e2e8f0)', color: '#162935', fontWeight: 700, fontSize: 17 }}>
                <th style={{ padding: '16px 8px', borderBottom: '2px solid #e2e8f0' }}>Name</th>
                <th style={{ padding: '16px 8px', borderBottom: '2px solid #e2e8f0' }}>Certificate ID</th>
                <th style={{ padding: '16px 8px', borderBottom: '2px solid #e2e8f0' }}>Department</th>
                <th style={{ padding: '16px 8px', borderBottom: '2px solid #e2e8f0' }}>Duration</th>
                <th style={{ padding: '16px 8px', borderBottom: '2px solid #e2e8f0' }}>Start Date</th>
                <th style={{ padding: '16px 8px', borderBottom: '2px solid #e2e8f0' }}>End Date</th>
                <th style={{ padding: '16px 8px', borderBottom: '2px solid #e2e8f0' }}>Issue Date</th>
                <th style={{ padding: '16px 8px', borderBottom: '2px solid #e2e8f0' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {certificates.map(cert => (
                <tr key={cert.certificateId} style={{ background: '#fff', transition: 'background 0.2s', borderBottom: '1px solid #f1f5f9' }} onMouseOver={e => e.currentTarget.style.background='#f4f6fa'} onMouseOut={e => e.currentTarget.style.background='#fff'}>
                  <td style={{ padding: '12px 8px' }}>{cert.name}</td>
                  <td style={{ padding: '12px 8px', fontFamily: 'monospace', color: '#64748b' }}>{cert.certificateId}</td>
                  <td style={{ padding: '12px 8px' }}>{cert.department}</td>
                  <td style={{ padding: '12px 8px' }}>{cert.duration}</td>
                  <td style={{ padding: '12px 8px' }}>{cert.startDate}</td>
                  <td style={{ padding: '12px 8px' }}>{cert.endDate}</td>
                  <td style={{ padding: '12px 8px' }}>{cert.issueDate}</td>
                  <td style={{ padding: '12px 8px', display: 'flex', gap: 8 }}>
                    <button onClick={() => { setShowDeleteConfirm(true); setDeleteTargetId(cert.certificateId); }} style={{ padding: '7px 18px', borderRadius: 8, background: '#ff4d4f', color: '#fff', border: 'none', fontWeight: 700, fontSize: 15, cursor: 'pointer', boxShadow: '0 1px 4px #0001', transition: 'background 0.2s' }}>Delete</button>
                    <button onClick={() => { setEditForm(cert); setShowEditModal(true); }} style={{ padding: '7px 18px', borderRadius: 8, background: 'linear-gradient(90deg,#FFC727,#FFD95A)', color: '#162935', border: 'none', fontWeight: 700, fontSize: 15, cursor: 'pointer', boxShadow: '0 1px 4px #0001', transition: 'background 0.2s' }}>Edit</button>
                  </td>
                </tr>
              ))}
              {(!loading && certificates.length === 0) && (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: 32, color: '#64748b', fontSize: 18 }}>No certificates found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 24, margin: '40px 0 0 0' }}>
          <button onClick={() => setShowVerifyModal(true)} style={{ padding: '18px 48px', borderRadius: 10, background: 'linear-gradient(90deg,#FFC727,#FFD95A)', color: '#162935', border: 'none', fontWeight: 800, fontSize: 22, cursor: 'pointer', boxShadow: '0 2px 8px #0002', letterSpacing: 1, marginRight: 8, transition: 'background 0.2s' }}>Verify Certificate</button>
          <button onClick={() => setShowAddModal(true)} style={{ padding: '18px 48px', borderRadius: 10, background: 'linear-gradient(90deg,#162935,#2c3f48)', color: '#fff', border: 'none', fontWeight: 800, fontSize: 22, cursor: 'pointer', boxShadow: '0 2px 8px #0002', letterSpacing: 1, transition: 'background 0.2s' }}>Add Certificate</button>
        </div>
        {showAddModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(34,34,34,0.18)',
            zIndex: 3000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 8px 32px 0 rgba(34,34,34,0.18)',
              padding: 0,
              position: 'relative',
              maxWidth: 700,
              width: '95vw',
              maxHeight: '95vh',
              overflowY: 'auto',
            }}>
              <button onClick={() => setShowAddModal(false)} style={{ position: 'absolute', top: 12, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#162935', cursor: 'pointer', zIndex: 10 }} title="Close">&times;</button>
              <div style={{ padding: 32 }}>
                <h2 style={{ color: '#162935', marginBottom: 24 }}>Add Certificate</h2>
                <form onSubmit={handleAdd} style={{
                  margin: '0 auto',
                  maxWidth: 600,
                  background: '#f4f6fa',
                  padding: 28,
                  borderRadius: 12,
                  boxShadow: '0 2px 12px #0001',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 16,
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                  <input type="text" placeholder="Name" value={addForm.name} onChange={handleNameChange} style={{ padding: 10, width: 180, borderRadius: 6, border: '1px solid #ccc' }} required />
                  <input type="text" placeholder="Certificate ID" value={addForm.certificateId} onChange={e => setAddForm({ ...addForm, certificateId: e.target.value })} style={{ padding: 10, width: 180, borderRadius: 6, border: '1px solid #ccc' }} required />
                  <input type="text" placeholder="Department" value={addForm.department} onChange={e => setAddForm({ ...addForm, department: e.target.value })} style={{ padding: 10, width: 140, borderRadius: 6, border: '1px solid #ccc' }} />
                  <input type="text" placeholder="Duration" value={addForm.duration} onChange={handleDurationChange} style={{ padding: 10, width: 100, borderRadius: 6, border: '1px solid #ccc' }} />
                  <span style={{ fontSize: 12, color: '#888', marginLeft: 4 }}>Enter a number, e.g. 1 or 2. 'month(s)' will be added automatically.</span>
                  <input type="date" placeholder="Start Date" value={addForm.startDate} onChange={e => setAddForm({ ...addForm, startDate: e.target.value })} style={{ padding: 10, width: 120, borderRadius: 6, border: '1px solid #ccc' }} />
                  <input type="date" placeholder="End Date" value={addForm.endDate} onChange={e => setAddForm({ ...addForm, endDate: e.target.value })} style={{ padding: 10, width: 120, borderRadius: 6, border: '1px solid #ccc' }} />
                  <input type="date" placeholder="Issue Date" value={addForm.issueDate} onChange={e => setAddForm({ ...addForm, issueDate: e.target.value })} style={{ padding: 10, width: 120, borderRadius: 6, border: '1px solid #ccc' }} />
                  <button type="submit" style={{ padding: '12px 32px', borderRadius: 6, background: 'linear-gradient(90deg,#162935,#2c3f48)', color: '#fff', border: 'none', fontWeight: 600, fontSize: 18, cursor: 'pointer', boxShadow: '0 2px 8px #0002' }}>Add</button>
                </form>
                {addStatus && <div style={{ color: 'red', marginTop: 16 }}>{addStatus}</div>}
              </div>
            </div>
          </div>
        )}
        {showThankYou && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(34,34,34,0.18)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 8px 32px 0 rgba(34,34,34,0.18)',
              padding: '48px 64px',
              textAlign: 'center',
              maxWidth: 400,
              width: '90vw',
              position: 'relative',
            }}>
              <button onClick={() => setShowThankYou(false)} style={{ position: 'absolute', top: 12, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#162935', cursor: 'pointer', zIndex: 10 }} title="Close">&times;</button>
              <div style={{ fontSize: 36, color: '#162935', fontWeight: 900, marginBottom: 12 }}>Thank You!</div>
              <div style={{ fontSize: 18, color: '#2c3f48', marginBottom: 8 }}>Certificate added successfully.</div>
              <div style={{ fontSize: 15, color: '#FFC727', fontWeight: 700 }}>You can view it in the list above.</div>
            </div>
          </div>
        )}
        {showDeleteSuccess && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(34,34,34,0.18)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 8px 32px 0 rgba(34,34,34,0.18)',
              padding: '48px 64px',
              textAlign: 'center',
              maxWidth: 400,
              width: '90vw',
              position: 'relative',
            }}>
              <button onClick={() => setShowDeleteSuccess(false)} style={{ position: 'absolute', top: 12, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#162935', cursor: 'pointer', zIndex: 10 }} title="Close">&times;</button>
              <div style={{ fontSize: 32, color: '#ff4d4f', fontWeight: 900, marginBottom: 12 }}>Deleted!</div>
              <div style={{ fontSize: 18, color: '#2c3f48', marginBottom: 8 }}>{deleteMessage}</div>
            </div>
          </div>
        )}
        {/* Delete Confirmation Modal */}
        {showDeleteConfirm && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(34,34,34,0.18)',
            zIndex: 4000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 8px 32px 0 rgba(34,34,34,0.18)',
              padding: '40px 48px',
              textAlign: 'center',
              maxWidth: 380,
              width: '90vw',
              position: 'relative',
            }}>
              <button onClick={() => { setShowDeleteConfirm(false); setDeleteTargetId(null); }} style={{ position: 'absolute', top: 12, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#162935', cursor: 'pointer', zIndex: 10 }} title="Close">&times;</button>
              <div style={{ fontSize: 24, color: '#162935', fontWeight: 700, marginBottom: 18 }}>Delete Certificate?</div>
              <div style={{ fontSize: 16, color: '#2c3f48', marginBottom: 24 }}>Are you sure you want to delete this certificate?</div>
              <div style={{ display: 'flex', justifyContent: 'center', gap: 18 }}>
                <button onClick={handleDeleteConfirmed} style={{ padding: '10px 28px', borderRadius: 6, background: '#ff4d4f', color: '#fff', border: 'none', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>Delete</button>
                <button onClick={() => { setShowDeleteConfirm(false); setDeleteTargetId(null); }} style={{ padding: '10px 28px', borderRadius: 6, background: '#ccc', color: '#162935', border: 'none', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>Cancel</button>
              </div>
            </div>
          </div>
        )}
        {/* Verify Certificate Modal */}
        {showVerifyModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(34,34,34,0.18)',
            zIndex: 3000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 8px 32px 0 rgba(34,34,34,0.18)',
              padding: 0,
              position: 'relative',
              maxWidth: 500,
              width: '95vw',
              maxHeight: '95vh',
              overflowY: 'auto',
            }}>
              <button onClick={() => { setShowVerifyModal(false); setVerifyInput(''); setVerifyResultModal(null); }} style={{ position: 'absolute', top: 12, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#162935', cursor: 'pointer', zIndex: 10 }} title="Close">&times;</button>
              <div style={{ padding: 32 }}>
                <h2 style={{ color: '#FFC727', marginBottom: 24 }}>Verify Certificate</h2>
                <form onSubmit={handleVerifyModal} style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 24 }}>
                  <input type="text" placeholder="Enter Certificate ID" value={verifyInput} onChange={e => setVerifyInput(e.target.value)} style={{ padding: 10, width: 240, borderRadius: 6, border: '1px solid #ccc' }} required />
                  <button type="submit" style={{ padding: '10px 24px', borderRadius: 6, background: 'linear-gradient(90deg,#FFC727,#FFD95A)', color: '#162935', border: 'none', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>Verify</button>
                </form>
                {verifyLoading && (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '24px 0' }}>
                    <div style={{ border: '4px solid #f3f3f3', borderTop: '4px solid #FFC727', borderRadius: '50%', width: 40, height: 40, animation: 'spin 1s linear infinite' }} />
                    <style>{'@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }'}</style>
                  </div>
                )}
                {verifyResultModal && typeof verifyResultModal === 'string' && (
                  <div style={{ color: 'red', fontWeight: 600, marginTop: 16 }}>{verifyResultModal}</div>
                )}
                {verifyResultModal && typeof verifyResultModal === 'object' && (
                  <>
                    <div style={{ marginTop: 16, background: '#f4f6fa', borderRadius: 10, padding: 24, boxShadow: '0 2px 8px #0001' }}>
                      <h3 style={{ color: '#162935', marginBottom: 12 }}>Certificate Details</h3>
                      <div><b>Name:</b> {verifyResultModal.name}</div>
                      <div><b>Certificate ID:</b> {verifyResultModal.certificateId}</div>
                      <div><b>Department:</b> {verifyResultModal.department}</div>
                      <div><b>Duration:</b> {verifyResultModal.duration}</div>
                      <div><b>Start Date:</b> {verifyResultModal.startDate}</div>
                      <div><b>End Date:</b> {verifyResultModal.endDate}</div>
                      <div><b>Issue Date:</b> {verifyResultModal.issueDate}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                      <button onClick={() => { setPreviewData(verifyResultModal); setShowPreviewModal(true); }} style={{ padding: '12px 32px', borderRadius: 6, background: 'linear-gradient(90deg,#162935,#2c3f48)', color: '#fff', border: 'none', fontWeight: 600, fontSize: 18, cursor: 'pointer', boxShadow: '0 2px 8px #0002' }}>Preview Certificate</button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {/* Edit Certificate Modal */}
        {showEditModal && editForm && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(34,34,34,0.18)',
            zIndex: 4000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              background: '#fff',
              borderRadius: 16,
              boxShadow: '0 8px 32px 0 rgba(34,34,34,0.18)',
              padding: 0,
              position: 'relative',
              maxWidth: 700,
              width: '95vw',
              maxHeight: '95vh',
              overflowY: 'auto',
            }}>
              <button onClick={() => { setShowEditModal(false); setEditForm(null); }} style={{ position: 'absolute', top: 12, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#162935', cursor: 'pointer', zIndex: 10 }} title="Close">&times;</button>
              <div style={{ padding: 32 }}>
                <h2 style={{ color: '#162935', marginBottom: 24 }}>Edit Certificate</h2>
                <form onSubmit={handleEditSave} style={{
                  margin: '0 auto',
                  maxWidth: 600,
                  background: '#f4f6fa',
                  padding: 28,
                  borderRadius: 12,
                  boxShadow: '0 2px 12px #0001',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 16,
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                  <input type="text" placeholder="Name" value={editForm.name} onChange={handleEditNameChange} style={{ padding: 10, width: 180, borderRadius: 6, border: '1px solid #ccc' }} required />
                  <input type="text" placeholder="Certificate ID" value={editForm.certificateId} readOnly style={{ padding: 10, width: 180, borderRadius: 6, border: '1px solid #ccc', background: '#eee' }} required />
                  <input type="text" placeholder="Department" value={editForm.department} onChange={e => setEditForm({ ...editForm, department: e.target.value })} style={{ padding: 10, width: 140, borderRadius: 6, border: '1px solid #ccc' }} />
                  <input type="text" placeholder="Duration" value={editForm.duration} onChange={handleEditDurationChange} style={{ padding: 10, width: 100, borderRadius: 6, border: '1px solid #ccc' }} />
                  <span style={{ fontSize: 12, color: '#888', marginLeft: 4 }}>Enter a number, e.g. 1 or 2. 'month(s)' will be added automatically.</span>
                  <input type="date" placeholder="Start Date" value={editForm.startDate} onChange={e => setEditForm({ ...editForm, startDate: e.target.value })} style={{ padding: 10, width: 120, borderRadius: 6, border: '1px solid #ccc' }} />
                  <input type="date" placeholder="End Date" value={editForm.endDate} onChange={e => setEditForm({ ...editForm, endDate: e.target.value })} style={{ padding: 10, width: 120, borderRadius: 6, border: '1px solid #ccc' }} />
                  <input type="date" placeholder="Issue Date" value={editForm.issueDate} onChange={e => setEditForm({ ...editForm, issueDate: e.target.value })} style={{ padding: 10, width: 120, borderRadius: 6, border: '1px solid #ccc' }} />
                  <button type="submit" style={{ padding: '12px 32px', borderRadius: 6, background: 'linear-gradient(90deg,#162935,#2c3f48)', color: '#fff', border: 'none', fontWeight: 600, fontSize: 18, cursor: 'pointer', boxShadow: '0 2px 8px #0002' }}>Save Changes</button>
                </form>
                {editSuccess && <div style={{ color: 'green', marginTop: 16, fontWeight: 600 }}>Certificate updated successfully!</div>}
              </div>
            </div>
          </div>
        )}
        {/* Certificate Preview Modal (after verification) - match main form design exactly */}
        {showPreviewModal && previewData && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(34,34,34,0.18)',
            zIndex: 4000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              background: '#fff',
              borderRadius: 24,
              boxShadow: '0 8px 32px 0 rgba(34,34,34,0.18)',
              padding: 0,
              position: 'relative',
              maxWidth: 1000,
              width: '95vw',
              maxHeight: '98vh',
              overflowY: 'auto',
            }}>
              <button onClick={() => setShowPreviewModal(false)} style={{ position: 'absolute', top: 12, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#162935', cursor: 'pointer', zIndex: 10 }} title="Close">&times;</button>
              <div style={{ padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {/* Main form certificate design (copy from App.js) */}
                <div
                  style={{
                    position: 'relative',
                    width: 900,
                    height: 640,
                    margin: '0 auto',
                    background: '#fff',
                    border: '6px solid #162935',
                    borderRadius: 32,
                    boxShadow: '0 8px 32px 0 rgba(34,34,34,0.18)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                  }}
                >
                  {/* Corners and Watermark */}
                  <svg style={{position:'absolute',top:-20,left:-20,zIndex:2}} width="120" height="120" viewBox="0 0 90 90">
                    <polygon points="0,0 90,0 0,90" fill="#FFC727" opacity="0.18"/>
                    <polygon points="0,0 70,0 0,70" fill="#162935" opacity="0.10"/>
                    <polyline points="0,0 70,70 0,90" fill="none" stroke="#FFE9A0" strokeWidth="3" opacity="0.7"/>
                  </svg>
                  <svg style={{position:'absolute',top:-20,right:-20,zIndex:2,transform:'scaleX(-1)'}} width="150" height="150" viewBox="0 0 90 90">
                    <polygon points="0,0 90,0 0,90" fill="#FFC727" opacity="0.18"/>
                    <polygon points="0,0 70,0 0,70" fill="#162935" opacity="0.10"/>
                    <polyline points="0,0 70,70 0,90" fill="none" stroke="#FFE9A0" strokeWidth="3" opacity="0.7"/>
                  </svg>
                  <svg style={{position:'absolute',bottom:-20,left:-20,zIndex:2,transform:'scaleY(-1)'}} width="150" height="150" viewBox="0 0 90 90">
                    <polygon points="0,0 90,0 0,90" fill="#FFC727" opacity="0.18"/>
                    <polygon points="0,0 70,0 0,70" fill="#162935" opacity="0.10"/>
                    <polyline points="0,0 70,70 0,90" fill="none" stroke="#FFE9A0" strokeWidth="3" opacity="0.7"/>
                  </svg>
                  <svg style={{position:'absolute',bottom:-20,right:-20,zIndex:2,transform:'scale(-1,-1)'}} width="120" height="120" viewBox="0 0 90 90">
                    <polygon points="0,0 90,0 0,90" fill="#FFC727" opacity="0.18"/>
                    <polygon points="0,0 70,0 0,70" fill="#162935" opacity="0.10"/>
                    <polyline points="0,0 70,70 0,90" fill="none" stroke="#FFE9A0" strokeWidth="3" opacity="0.7"/>
                  </svg>
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%) rotate(-20deg)',
                    fontSize: 81.5,
                    color: '#FFC727',
                    opacity: 0.18,
                    fontWeight: 900,
                    pointerEvents: 'none',
                    zIndex: 0,
                    userSelect: 'none',
                    whiteSpace: 'nowrap',
                    letterSpacing: 4,
                    fontFamily: 'Montserrat, Arial, sans-serif',
                    textShadow: '0 2px 8px #fff',
                    width: '100%',
                    textAlign: 'center',
                    lineHeight: 1.1
                  }}>
                    GLOBAL SERVICEX
                  </div>
                  {/* Badge */}
                  <div style={{ position: 'absolute', top: 40, right: 60, zIndex: 2, width: 120, height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src="/badge.png" alt="Badge" style={{ width: 120, height: 120, objectFit: 'contain' }} onError={e => { e.target.onerror = null; e.target.src = '/badge.jpg'; }} />
                  </div>
                  {/* Centered Content */}
                  <div style={{
                    width: '100%',
                    maxWidth: 700,
                    margin: '0 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 2,
                    position: 'relative',
                    marginBottom: 100,
                  }}>
                    {/* Logo and tagline */}
                    <img src="/logo.png" alt="Logo" style={{ width: 90, height: 90, borderRadius: '50%', marginBottom: 8, objectFit: 'cover', background: '#fff', border: '2px solid #2c3f48' }} />
                    <div style={{ fontSize: 32, color: '#162935', fontWeight: 900, letterSpacing: 2 }}>GLOBAL SERVICEX</div>
                    <div style={{ fontSize: 15, color: '#FFC727', marginBottom: 8, fontWeight: 700 }}>Technology | Design | Growth</div>
                    <div style={{ fontSize: 26, color: '#162935', fontWeight: 600, marginBottom: 8, letterSpacing: 1 }}>Certificate of Completion</div>
                    <div style={{ fontSize: 16, color: '#2c3f48', marginBottom: 20 }}>This is to certify that</div>
                    <div style={{ fontSize: 24, color: 'red', fontWeight: 700, marginBottom: 14, letterSpacing: 1, textTransform: 'uppercase' }}>{previewData.name}</div>
                    <div style={{ fontSize: 16, color: '#2c3f48', marginBottom: 8 }}>has successfully completed a</div>
                    <div style={{ fontSize: 20, color: '#162935', fontWeight: 700, marginBottom: 8 }}>
                      <b>{(() => {
                        const n = Number(previewData.duration);
                        if (!isNaN(n) && n > 0) {
                          return n + ' month' + (n === 1 ? '' : 's');
                        }
                        return previewData.duration;
                      })()}</b> <b>Internship Program</b>
                    </div>
                    <div style={{ fontSize: 16, color: '#2c3f48', marginBottom: 8 }}>at Global ServiceX in the domain of</div>
                    <div style={{ fontSize: 20, color: '#162935', fontWeight: 700, marginBottom: 14 }}><b>{previewData.department}</b></div>
                    <div style={{ fontSize: 15, color: '#2c3f48', marginBottom: 14 }}>
                      During the internship period from <b>{previewData.startDate}</b> to <b>{previewData.endDate}</b>,<br />
                      the intern has demonstrated consistent dedication, strong work ethic,<br />
                      and valuable contributions to ongoing projects and team activities.
                    </div>
                    <div style={{ fontSize: 15, color: '#2c3f48', marginBottom: 14 }}>
                      We truly appreciate their efforts and wish them the best for future endeavors.
                    </div>
                  </div>
                  {/* Bottom Info: Issued at, Date, Certificate ID (bottom left, flush to border) */}
                  <div style={{ position: 'absolute', bottom: 16, left: 16, zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', fontSize: 15, color: '#888' }}>
                    <div style={{ marginBottom: 2 }}><span style={{ fontSize: 17 }}>📍</span> Issued at: Global ServiceX, Dehradun, Uttarakhand</div>
                    <div style={{ marginBottom: 2 }}><span style={{ fontSize: 17 }}>🗓️</span> Date of Issue: {previewData.issueDate}</div>
                    <div><span style={{ fontSize: 17 }}>🔒</span> Certificate ID: <span style={{ color: '#1976d2', fontWeight: 700, textDecoration: 'underline', cursor: 'pointer' }}>{previewData.certificateId}</span></div>
                    <div style={{ marginTop: 2 }}><span style={{ fontSize: 17 }}>🏢</span> Udyam Registration Number: {UDYAM_REG_NUMBER}</div>
                  </div>
                  {/* Bottom Right: Signature, Name, Title (flush to border) */}
                  <div style={{ position: 'absolute', bottom: 16, right: 16, zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <img src="/signature.png" alt="Signature" style={{ width: 120, height: 60, objectFit: 'contain', marginBottom: 2 }} />
                    <div style={{ fontSize: 17, color: '#162935', fontWeight: 700 }}>Alok Mishra</div>
                    <div style={{ fontSize: 13, color: '#888' }}>Founder & CEO</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showAddUserModal && (
          <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(34,34,34,0.18)', zIndex: 5000, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 8px 32px 0 rgba(34,34,34,0.18)', padding: 32, minWidth: 340, position: 'relative' }}>
              <button onClick={() => { setShowAddUserModal(false); setAddUserStatus(''); }} style={{ position: 'absolute', top: 12, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#162935', cursor: 'pointer', zIndex: 10 }} title="Close">&times;</button>
              <h2 style={{ color: '#162935', marginBottom: 18 }}>Add Admin User</h2>
              <form onSubmit={handleAddUser} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <input type="text" placeholder="Username" value={addUserForm.username} onChange={e => setAddUserForm({ ...addUserForm, username: e.target.value })} style={{ padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} required />
                <input type="email" placeholder="Email" value={addUserForm.email} onChange={e => setAddUserForm({ ...addUserForm, email: e.target.value })} style={{ padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} required />
                <input type="password" placeholder="Password" value={addUserForm.password} onChange={e => setAddUserForm({ ...addUserForm, password: e.target.value })} style={{ padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} required />
                <label style={{ fontSize: 15, color: '#162935', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input type="checkbox" checked={addUserForm.is_admin} onChange={e => setAddUserForm({ ...addUserForm, is_admin: e.target.checked })} />
                  Is Admin
                </label>
                <button type="submit" style={{ padding: '10px 0', borderRadius: 8, background: 'linear-gradient(90deg,#162935,#2c3f48)', color: '#fff', border: 'none', fontWeight: 700, fontSize: 17, cursor: 'pointer', marginTop: 8 }}>Add User</button>
                {addUserStatus && <div style={{ color: addUserStatus.startsWith('Error') ? 'red' : 'green', marginTop: 8 }}>{addUserStatus}</div>}
              </form>
              <div style={{ color: '#888', fontSize: 13, marginTop: 12 }}>
                <b>Note:</b> For demo only. In production, always hash passwords and use HTTPS.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPanel; 